import React from "react";
import { graphql } from "gatsby";
import { PageLayout } from "components/pages";
import { CenterLayout, Layout3, GridLayout3 } from "components/layouts";
import { Header } from "components/typography";
import ProjectCard from "pages-components/projects/ProjectCard";

export default function projects({ data }) {
  const groups = data.allFile.group;

  return (
    <PageLayout title="Projects">
      <CenterLayout>
        <Layout3>
          <Header>Projects</Header>

          <GridLayout3>
            {groups.map((item, index) => {
              const { nodes } = item;
              const markdown = nodes[0].childMarkdownRemark;
              const image = nodes[1];

              return (
                <ProjectCard
                  key={index}
                  imageData={image}
                  markdown={markdown}
                />
              );
            })}
          </GridLayout3>
        </Layout3>
      </CenterLayout>
    </PageLayout>
  );
}

export const query = graphql`
  query projectsData {
    allFile(
      filter: {relativeDirectory: {regex: "/\\projects/"}}
      sort: {fields: ext}
    ) {
      group(field: relativeDirectory) {
        nodes {
          id
          base
          extension
          childMarkdownRemark {
            frontmatter {
              path
              to
              title
              date
              excerpt
            }
          }
          childrenImageSharp {
            gatsbyImageData(aspectRatio: 1.77, transformOptions: {fit: FILL})
          }
        }
      }
    }
  }
`;
